import { Button } from '@unified-checkout/design-system';
import {
  ContactForm,
  IContactFormHandle,
} from '@unified-checkout/kit-components';
import { useEditUserInfo } from 'apps/customer/src/services/inner_layout/auth';
import { getUserData } from 'apps/customer/src/utils';
import { getDomainCountry } from 'libs/kit-components/src/utils/getDomainCountry';
import { useEffect, useMemo, useRef, useState } from 'react';
import parsePhoneNumber from 'libphonenumber-js/max';

export const EditContactForm = () => {
  const country = getDomainCountry();
  const contactFormRef = useRef<IContactFormHandle>(null);
  const [isValid, setIsValid] = useState(false);


  const profileData = getUserData();
  const {
    fullName,
    email,
    phone,
    isEmailVerified,
    isPhoneVerified,
  } = profileData || {};

  const countryIso = useMemo(() => {
      const parsed = parsePhoneNumber(phone);

      return parsed?.isValid() ? parsed.country : undefined;
  }, [phone]);

  const disabledFields = {
    email: true,
    phone: true,
  };
  const verifiedFields = {
    email: isEmailVerified,
    phone: isPhoneVerified,
  };
  const {
    mutate: editUserMutation,
    isPending: isPendingEdit,
    isSuccess: isSuccessEdit,
  } = useEditUserInfo();

  useEffect(() => {
    if (!isPendingEdit && isSuccessEdit) {
      setIsValid(false);
    }
  }, [isPendingEdit, isSuccessEdit]);

  const handleSaveChanges = () => {
    const { name } = contactFormRef.current?.getFormFields() || {};

    name &&
      editUserMutation({
        full_name: name || '',
      });
  };
  return (
    <>
      <ContactForm
        defaultValues={{
          email,
          phone,
          name: fullName,
        }}
        needsEmail
        needsName
        needsPhone
        onValidityChange={(isValid, isDirty) => setIsValid(isValid && isDirty)}
        ref={contactFormRef}
        disableFields={disabledFields}
        disableDropdown={{ phone: true }}
        verifiedFields={verifiedFields}
        defaultCountryISO={countryIso || country.iso}
        phoneRequired={true}
        emailRequired={true}
        nameRequired={false}
        mode="onBlur"
      />
      <div className="[&_button]:w-full mt-3">
        <Button
          color="primary"
          text="Save"
          type="submit"
          size="md"
          disabled={!isValid || isPendingEdit}
          onClickHandler={handleSaveChanges}
        />
      </div>
    </>
  );
};
